import { inject } from "vue";
import { prismicKey } from "./injectionSymbols.js";
const usePrismic = () => {
  return inject(prismicKey, { options: { endpoint: "" } });
};
export {
  usePrismic
};
//# sourceMappingURL=usePrismic.js.map
